module.exports = __webpack_public_path__ + "static/media/20240213112628_IMG_5375.5bec3c6d.JPG";